import { CatButton } from '@blocks-react/components/Button';
import { ContactYourDealerBtnProps } from '../../types';

export const ContactYourDealerBtn = ({
  children,
  ...buttonProps
}: ContactYourDealerBtnProps) => {
  return (
    <CatButton
      size="sm"
      fullWidth
      slot="trigger"
      data-track-event="e_primaryCTA"
      data-track-attr-nltext="Contact Dealer"
      {...buttonProps}
    >
      {children}
    </CatButton>
  );
};
